'use client';

import { PropsWithChildren } from 'react';
import { usePathname } from 'next/navigation';
import cn from 'classnames';

import styles from './index.module.css';

export const Container = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();
  const isRecruiterRoute = pathname.includes('/admin');

  return (
    <main
      className={cn(styles.root, {
        [styles.rootCreamBackground]: !isRecruiterRoute,
        [styles.rootWhiteBackground]: isRecruiterRoute,
      })}
    >
      {children}
    </main>
  );
};
